<template>
    <LayoutContainer class="global-alignment-settings">
        <LayoutColumn full>
            <SectionTitle>
                {{ $t('Search.labels.algorithmSettings') }}
            </SectionTitle>
            <SectionBlock class="global-alignment-settings__section">
                <div class="global-alignment-settings__fields">
                    <slot name="before-fields" />
                    <MatchWithGapsField />
                    <AlignmentIdentityField />
                    <NwNumberField
                        v-if="isNucleotide"
                        fieldName="nw_match_score"
                    />
                    <NwNumberField
                        v-if="isNucleotide"
                        fieldName="nw_mis_match_score"
                    />
                    <NwNumberField fieldName="nw_gap_extend" />
                    <NwNumberField fieldName="nw_gap_open" />
                    <NWScoreMatrixField fieldName="nw_score_matrix" />
                    <slot name="extra-fields" />
                </div>
            </SectionBlock>
        </LayoutColumn>
    </LayoutContainer>
</template>

<script>
import {
    AlignmentIdentityField,
    LayoutColumn,
    LayoutContainer,
    MatchWithGapsField,
    NWScoreMatrixField,
    SectionBlock,
    SectionTitle,
} from '@patsnap-biz/bio-search-setting';
import NwNumberField from './nw-number-field.vue';
import { initializeNwFields } from './nw-field-configs';

export default {
    name: 'GlobalAlignmentSettings',
    components: {
        AlignmentIdentityField,
        LayoutColumn,
        LayoutContainer,
        MatchWithGapsField,
        NWScoreMatrixField,
        NwNumberField,
        SectionBlock,
        SectionTitle,
    },
    inject: ['store'],
    computed: {
        isNucleotide() {
            return this.store?.settingValues?.sequenceType === 'NUCLEOTIDE';
        },
    },
    mounted() {
        initializeNwFields(this.store);
    },
};
</script>

<style lang="scss">
.global-alignment-settings {
    > .search-preferences-new--item {
        flex: 1 1 100%;
        width: 100%;
        min-width: 0;
    }

    &__section {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    &__fields {
        width: calc(50% - 6px);
        min-width: 0;
        text-align: left;

        > .row-space {
            display: block;

            > .search-preference__title {
                display: block;
            }

            > .search-preferences--number-input {
                display: flex;
                width: 100%;
            }
        }
    }
}
</style>
